import PropertyDetailsModal from '../../PropertyDetailsModal';

type Props = {
  isOpen: boolean;
  floorPlanId: string;
  onClose: () => void;
  onConfirm: () => void;
};

const PropertyDetailsStep = ({ isOpen, floorPlanId, onClose, onConfirm }: Props): JSX.Element => {
  return (
    <PropertyDetailsModal
      isOpen={isOpen}
      floorPlanId={floorPlanId}
      onClose={onClose}
      onConfirm={onConfirm}
      submitLabel="Continue"
    />
  );
};

export default PropertyDetailsStep;
